<template>
  <div>
    <div
      v-if="visible"
      class="overlay"
      @click="visible = false"
    ></div>

    <div 
      class="menu_main bg_c9"
      :class="{ show: visible}"
    >
      <div
        id="btnClose"
        class="btn_close"
        @click="visible = false"
      >
        <i class="fas fa-times"></i>
      </div>
      <div class="head pa-5">
        <div class="img">
          <img
            src="@/assets/v3/profile/profile.png"
            alt=""
            class="img-profile"
          />
        </div>
        <div class="txt ps-4">
          <p>
            {{ userProfile.username }}
          </p>
          <p class="t-medium">
            เครดิต: {{ wallet.amount }}
          </p>
        </div>
      </div>
      <div class="line-between mb-2"></div>
      <div 
        v-for="(item,i) in userProfile.user_stake_summary"
        :key="i" 
        class="px-5"
      >
        <div class="d-flex align-items-center credit">
          <p class="bdr-5 bg_c20 p-1">
            {{ $t('number-play') }}{{ item.category_game_type.name }} 
          </p>

          <p class="t-medium ms-3">
            {{ item.amount }}
          </p>
        </div>
      </div>
      
      <div class="line-between my-2"></div>
      <div class="menu_list px-3">
        <div
          v-for="(item, i) in items"
          :key="i"
          class="menu_item"
          @click="goTo(item)"
        >
          <img
            :src="item.img"
            class="img"
          />

          <p class="">
            {{ item.name }}
          </p>
        </div>
        <div
          class="menu_item"
          @click="$refs.rule.open()"
        >
          <img
            src="@/assets/v3/navbar/pin.svg"
            class="img"
          />
          <p class="">
            {{ $t('rules-regulation') }}
          </p>
        </div>
      </div>
      <div class="line-between my-2"></div>
      <div class="foot px-3">
        <div
          class="menu_item"
          @click="logout()"
        >
          <img
            src="@/assets/v3/navbar/logout.svg"
            class="img"
          />
          <p class="t-medium">
            ออกจากระบบ
          </p>
        </div>
      </div>
    </div>
    <dialog-rule-main ref="rule"></dialog-rule-main>
    <dialog-contact-agent ref="dialogContactAgent" />
  </div>
</template>
<script> 
import { 
  auth as apiAuth,
} from '@/apis' 
import DialogRuleMain from '@/components/Dialog/DialogRuleMain'   
import { ROUTE_INDEX, ROUTE_CONTACT } from '@/const/route' 
import dialogContactAgent from '@/components/Dialog/DialogContactAgent'
export default {
  components : {
    DialogRuleMain,
    dialogContactAgent
  },
  data: () => ({
    visible: false,
  }),
  computed : {
    items () { 
      return this.$store.getters['sidebarItems/GETTERS_ITEMS'] 
    },
    wallet () {
      return this.$store.getters['userProfile/GETTERS_WALLET']
    },
    userProfile () {
      return this.$store.getters['userProfile/GETTERS_ME']
    },
  },
  methods: {
    goTo (item) { 
      if(item.newtab) { 
        window.open(item.to, '_blank');
      } else if (item.pathName == ROUTE_CONTACT) {
        this.$refs.dialogContactAgent.open()
      } else {
        this.$router.push({ name: item.pathName }).catch(()=>{}); 
      }
      this.GAsidebar(item.name)
      this.visible = false
    },
    openSideBar () {
      this.$ga.event('Button', 'OpenSideBarMobile', 'SideBar-V2','' ) 
      this.visible=!this.visible
    },
    GAsidebar (name){
      this.$ga.event('Button', 'SelectPage', 'SideBar-V2',name )
    },

    async logout () {
      this.$confirm('',this.$t('confirm.logout'),'warning').then(async ()=>{ 
        // window.removeEventListener('focus', this.checkCurrentGame);
        await apiAuth.logout() 
        this.$store.dispatch('auth/ACTION_LOGOUT') 
        this.$ga.event('Button', 'Logout', 'SideBar-V2','' )

        this.$router.push({ name: ROUTE_INDEX }).then(() => {
          location.reload(); // Forces a full page reload
         
        }).catch(() => {});
      }) 
    },
  }
}
</script>
<style scoped>
.overlay {
  width: 100%;
  height: 100vh;
  position: fixed;
  display: block;
  left: 0;
  top: 0;
  z-index: 109;
  background: rgba(0, 0, 0, 0.5);
  transition: all 0.3s;
}

.menu_main {
  width: 350px;
  height: 100vh;
  overflow: auto;
  left: 0;
  top: 0;
  position: fixed;
  z-index: 110;
  padding-top: 20px;
  transform: translateX(-350px);
  transition: all 0.3s;
  padding-bottom: 40px;
}
.menu_main .btn_close {
  width: 30px;
  height: 30px;
  position: fixed;
  right: 10px;
  top: 10px;
  background: rgba(255, 255, 255, 0.8);
  font-size: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #000;
  cursor: pointer;
}
.menu_main .line-between {
  border-bottom: 1px solid #e4e4e4;
}
.menu_main .head {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
}
.menu_main .head .img {
  width: 80px;
}
.menu_main .credit {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
}
.menu_main .credit .img-level {
  width: 40px;
}
.menu_main .menu_item {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  margin-bottom: 10px;
  color: #000;
  padding-left: 10px;
  cursor: pointer;
  font-weight: bold;
}
.menu_main .menu_item .img {
  width: 34px;
  margin-right: 26px;
}
.menu_main .foot {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
}
.menu_main.show {
  transform: translateX(0);
}

.bg_c9 {
  background: #fff;
}

.img-profile {
  width: 100%;
}

.t-medium {
  font-weight: bold;
}

p {
  margin-bottom: 0;
  /* font-weight: bold; */
  font-size: 14px;
}

@media only screen and (max-width: 767px) {
  .menu_main {
    width: 280px;
    /* transform: translateX(280px); */
  }
}
</style>